import { render, staticRenderFns } from "./OtherPaymentTest.vue?vue&type=template&id=4bceeec8&scoped=true&"
import script from "./OtherPaymentTest.vue?vue&type=script&lang=js&"
export * from "./OtherPaymentTest.vue?vue&type=script&lang=js&"
import style0 from "./OtherPaymentTest.vue?vue&type=style&index=0&id=4bceeec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bceeec8",
  null
  
)

export default component.exports